var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"mb-3 select-service-container"},[_c('select',{ref:"input",staticClass:"form-control form-control-lg service-tom-selector",attrs:{"multiple":"","placeholder":"Add a service"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }